import { OAuth } from './oauth';

export class GoogleAuth {
    init() {
        const initGoogleInstance = () => {
            const googleInstance = (window as any).google;
            if (typeof googleInstance !== "undefined") {
                let clientId = document.querySelector('meta[name="google-signin-client_id"]').getAttribute('content');
                googleInstance.accounts.id.initialize({
                    client_id: clientId,
                    callback: OAuth.onSignIn
                });
            } else {
                console.log('Google auth not supporter on this domain');
            }
        }

        window.addEventListener("load", (event) => {
            initGoogleInstance();
        });
    }

    
}


